import React from 'react'

import NavContainer from './NavContainer'

const Header = () => {
  return (
    <nav>
      <NavContainer />
    </nav>
  )
}

export default Header
